import {EVENT_PREFIX} from '../../../helpers';

export default (instanceKey, stateKey) => ({
  ...{
    type: `${EVENT_PREFIX}_SET_SUBMITTING`
  },
  instanceKey,
  stateKey
});
